/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/pointindicator/pointindicator_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ REWARDS : POINT INDICATOR : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
class PointIndicator extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showIndicator: false
		}
	}
	showPoints(points) {
        // Don't show this Indicator on the Question Rewards Phase
        if (this.shouldRemoveIndicator()) { return ''; }
		const pointText = points === 1 ? 'point' : 'points';
		return points !== undefined ? `${points} ${pointText}` : ``;
	}
	handleContentTypeCases() {
		let points;
		switch (this.props.currentContentSettings.type) {
			case 'quiz':
			case 'poll':
			case 'mixed':
				const dataType = !!this.props.currentContentData ? this.props.currentContentData.type : null;
				points = !!dataType ? this.props.rewardsSettings.pointValues[dataType] : 0;
				break;
			case 'marketResearch':
				const mrProvider = this.props.rewardStatus.marketResearch[this.props.contentId]["marketResearchProvider"];
				points = this.props.rewardsSettings.pointValues.marketResearch[mrProvider];
				break;
			case 'questionnaire':
				const questionnaireType = this.props.currentContentSettings.uniqueProps.questionnaireType.toLowerCase();
				if (!!this.props.rewardsSettings.pointValues.profileQuestions) { // temporal fall back for new setting for profile questions points values
                    points = this.props.rewardsSettings.pointValues.profileQuestions[questionnaireType];
                } else if (!!this.props.rewardsSettings.pointValues) {
                    points = this.props.rewardsSettings.pointValues['profile'];
                } else {
					points = 0;
				}
                break;
            default:
				return null;
		}
        return this.showPoints(points);
	}
    shouldRemoveIndicator() {
        if (this.props.currentContentSettings.type === 'questionnaire') {
            return this.props.screenStatus.visible;
        } else {
            return this.props.currentContentStatus.uniqueState !== undefined &&
                this.props.currentContentStatus.uniqueState.frameStatus &&
                !!this.props.currentContentStatus.uniqueState.frameStatus[this.props.currentContentStatus.frame] &&
                this.props.currentContentStatus.uniqueState.frameStatus[this.props.currentContentStatus.frame]['state'].includes('rewards')
        }
    }
	render() {
        return (
            <span className={`${sheet.classes.pointindicator} pointindicator`}>
        		{this.handleContentTypeCases()}
        	</span>
        );
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default PointIndicator;
